import clsx from 'clsx'

import { ContributionRatio } from './ContributionRatio'
import { PowerSources } from './PowerSources'
import { StepSlider } from './StepSlider'

interface PowerSourcesProps {
  className?: string
  active?: boolean
}

export function NaturalPowerContribution({ className, active }: PowerSourcesProps) {
  return (
    <>
      <div className={clsx('flex flex-col items-center justify-end pt-10 gap-y-3', className)}>
        <PowerSources />
        <div className="relative w-full h-10 -top-5">
          {active && (
            <StepSlider className="h-10">
              <StepSlider.Track className="h-10 px-8 sm:px-4 md:h-8 md:px-9 top-1 md:top-0.5">
                <StepSlider.MaxLabel>
                  Greatest CO<sub>2</sub> reduction
                </StepSlider.MaxLabel>
              </StepSlider.Track>
              <StepSlider.Thumb className="w-14 md:w-16 h-9 md:h-8" name="🟡" />
            </StepSlider>
          )}
        </div>
      </div>
      <ContributionRatio />
    </>
  )
}
